import ApiService from "../ApiService";

import Axios from "axios";

const AppointmentService = {
  statesAppointment(countryId) {
    countryId = countryId || 1;
    return ApiService.customRequest({
      url: `${ApiService.farmadomiciliosApiURL}/state/search-state-by-branch/${countryId}`,
    });
  },
  cityAppointment(cityId) {
    cityId = cityId || 1;
    return ApiService.customRequest({
      url: `${ApiService.farmadomiciliosApiURL}/city/by-state-branch/${cityId}`,
    });
  },
  getBranchesAppointment(sedeId) {
    sedeId = sedeId || 0;
    return ApiService.customRequest({
      url: `${ApiService.farmadomiciliosApiURL}/branch/get-all-branch-by-delivery-point/${sedeId}`,
    });
  },
  getDayAttentionByBranch(idBranch) {
    return ApiService.customRequest({
      url: `${ApiService.farmadomiciliosApiURL}/appointment/get-day-attention-by-branch/${idBranch}`,
    });
  },

  getCalendarAppointment(idBranch, day) {
    return ApiService.customRequest({
      url: `${ApiService.farmadomiciliosApiURL}/appointment/get-shifts-by-delivey-point/${idBranch}/day/${day}`,
    });
  },
  getMotivosCancel() {
    return ApiService.customRequest({
      url: `${ApiService.farmadomiciliosApiURL}/appointment-cancel-reason`,
      method: "GET",
      headers: {
        "user-id": 15,
        "x-request-public-key": process.env.VUE_APP_FARMADOMICILIOS_CLIENT_KEY,
      },
    });
  },
  saveAppointment(data) {
    return ApiService.customRequest({
      url: `${ApiService.farmadomiciliosApiURL}/appointment`,
      data,
      method: "POST",
      headers: {
        "user-id": 15,
        "x-request-public-key": process.env.VUE_APP_FARMADOMICILIOS_CLIENT_KEY,
      },
    });
  },
  editAppointment(data) {
    return ApiService.customRequest({
      url: `${ApiService.farmadomiciliosApiURL}/appointment/edit`,
      data,
      method: "POST",
      headers: {
        "user-id": 15,
        "x-request-public-key": process.env.VUE_APP_FARMADOMICILIOS_CLIENT_KEY,
      },
    });
  },
  cancelAppointment(data){
    return ApiService.customRequest({
      url: `${ApiService.farmadomiciliosApiURL}/appointment/cancel`,
      data,
       method: "POST",
      headers: {
        "user-id": 15,
        "x-request-public-key": process.env.VUE_APP_FARMADOMICILIOS_CLIENT_KEY,
      },
    });
  },
  comfirmarAppointment(data){
    return ApiService.customRequest({
      url: `${ApiService.farmadomiciliosApiURL}/appointment/confirm`,
      data,
       method: "POST",
      headers: {
        "user-id": 15,
        "x-request-public-key": process.env.VUE_APP_FARMADOMICILIOS_CLIENT_KEY,
      },
    });
  },
  getAllowedDates(deliveryPoint, userIsAdmin) {
    return ApiService.customRequest({
      url: `${ApiService.farmadomiciliosApiURL}/calendar-configuration-appointment/getAllowedDates?deliveryPoint=${deliveryPoint}&userIsAdmin=${userIsAdmin}`,
    });
  },

  getScheduleRanges(id, userIsAdmin) {
    return ApiService.customRequest({
      url: `${ApiService.farmadomiciliosApiURL}/calendar-configuration-appointment/getScheduleRanges?id=${id}&userIsAdmin=${userIsAdmin}`,
    });
  },

  getDeliveryPointByCity(city, userId) {
    return ApiService.customRequest({
      url: `${ApiService.farmadomiciliosApiURL}/delivery-point/getByCity?city=${city}`,
      headers: {
        "user-id": userId,
      },
    });
  },

  getAllowedDates(deliveryPoint, userIsAdmin) {
    return ApiService.customRequest({
      url: `${ApiService.farmadomiciliosApiURL}/calendar-configuration-appointment/getAllowedDates?deliveryPoint=${deliveryPoint}&userIsAdmin=${userIsAdmin}`,
    });
  },

  getScheduleRanges(id, userIsAdmin) {
    return ApiService.customRequest({
      url: `${ApiService.farmadomiciliosApiURL}/calendar-configuration-appointment/getScheduleRanges?id=${id}&userIsAdmin=${userIsAdmin}`,
    });
  },
  getListApointment(data) {
    // return ApiService.customRequest({
    //   url: `${ApiService.farmadomiciliosApiURL}/appointment/search`, data
    // });

    return ApiService.customRequest({
      url: `${ApiService.farmadomiciliosApiURL}/appointment/search`,
      data,
      method: "POST",
      headers: {
        "user-id": 15,
        "x-request-public-key": process.env.VUE_APP_FARMADOMICILIOS_CLIENT_KEY,
      },
    });

    
  },
};
export default AppointmentService;
